<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8x2t9d/tc-custom/9781683358015.jpg?1701542632226" alt="This image is the cover for the book Burnt Orange Heresy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Burnt Orange Heresy
      </h1>
      <p class="bookDescription body article font2">
        <b>A driven art critic’s plan to steal a painting leads to murder in this classic neo-noir novel by the author of the Hoke Moseley series.</b><br/><br/>Fast-talking, backstabbing, womanizing, and fiercely ambitious art critic James Figueras will do anything—blackmail, burglary, and beyond—to make a name for himself. When an unscrupulous collector offers Figueras a career-making chance to interview Jacques Debierue, the greatest living—and most reclusive—artist, the critic must decide how far he will go to become the art-world celebrity he hungers to be. Will Figueras stop at the opportunity to skim some cream for himself or push beyond morality’s limits to a bigger payoff?<br/><br/>Crossing the art world with the underworld, Willeford creates a novel of dark hue and high aesthetic polish<i>. The Burnt Orange Heresy</i>—the 1970s crime classic now back in print—has lost none of its savage delights as it re-creates the making of a murderer, calmly and with exquisite tension, while satirizing the workings of the art world as the ultimate con.<br/><br/><b>Now a major motion picture starring Donald Sutherland and Mick Jagger</b><br/><br/><b>Praise for <i>The Burnt Orange Heresy</i></b><br/><br/><b>“Stunning . . . A novel full of genuine fun that also manages to make a level statement about the art world and its hermetic credulities.” —<i>New Yorker</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Willeford
      </h2>
      
      <p class="authorDescription body article">Charles Willeford (1919–1988) was an American writer of fiction, poetry, autobiography, literary criticism, and 20 novels, best known for his Hoke Moseley series, including Miami Blues, as well as such classics as Cockfighter and The Woman Chaser. The Burnt Orange Heresy is now adapted into an upcoming film starring Claes Bang, Donald Sutherland, Elizabeth Debicki, and Mick Jagger.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13f00a8a